import { getRequest } from 'src/state/utils'

export const getProjects: RequestTypeVariable = {
  getKey: (includeTrash = false) => ['getProjects', includeTrash],
  request: async (includeTrash = false): Promise<ProjectData[]> => {
    const res = await getRequest<ProjectData[]>({
      url: '/projects',
      params: includeTrash ? { include_trash: true } : undefined,
    })

    return res.data as ProjectData[]
  },
}

export const getProject: RequestTypeVariable = {
  getKey: (id: string) => ['getProject', id],
  request: async (id: string): Promise<ProjectWithLoadInfo> => {
    const res = await getRequest<ProjectWithLoadInfo>({
      url: `/projects/${id}`,
    })

    return res.data as ProjectWithLoadInfo
  },
}

export const getBackendOtherSettings: RequestTypeVariable = {
  getKey: (projectId: string) => ['getBackendOtherSettings', projectId],
  request: async (id: string): Promise<BackendOtherSettings> => {
    const { data } = await getRequest<BackendOtherSettings>({
      url: `/projects/${id}/other-settings`,
    })

    return data as BackendOtherSettings
  },
}
